var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: 'rounded tit-txt font-weight-bold text-center ' + _vm.className
  }, [_c('div', {
    staticClass: "head-priamry",
    style: 'background-color:' + _vm.bgColor + ';'
  }, [_c('h5', {
    staticClass: "color-white"
  }, [_vm._v(" " + _vm._s(_vm.tit) + " ")])]), _c('div', {
    staticClass: "pa-20 pa-md-30 py-lg-34",
    staticStyle: {
      "background-color": "#ebf5ff"
    }
  }, [_c('h5', [_vm._t("default")], 2)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }